/**
 * ResizeHandle Component
 * Vertical drag handle for resizing columns in the expanded load detail pane.
 * Ported from new-agent-numeo reference (App.tsx lines 6104-6153).
 *
 * Visual: 8px wide flex column
 *   - full-height vertical line (1px) behind dots
 *   - centered 2×3 grid of 2px dots
 * Hover: line turns accent blue, dots grid gets accent-soft bg + dots opacity 0.5
 */

import React, { useState } from 'react'

interface ResizeHandleProps {
    onMouseDown: (e: React.MouseEvent) => void
}

export const ResizeHandle: React.FC<ResizeHandleProps> = ({ onMouseDown }) => {
    const [hovered, setHovered] = useState(false)

    return (
        <div
            onMouseDown={onMouseDown}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            className="w-2 flex-shrink-0 relative cursor-col-resize flex items-center justify-center"
        >
            {/* Vertical separator line */}
            <div
                className="absolute top-0 bottom-0 left-1/2 w-px -translate-x-1/2 transition-colors"
                style={{ background: hovered ? 'var(--lh-accent)' : 'var(--lh-border)' }}
            />
            {/* Drag indicator dots (2 cols × 3 rows) */}
            <div
                className="relative z-[1] grid gap-[1px] rounded-sm transition-colors"
                style={{
                    gridTemplateColumns: 'repeat(2, 2px)',
                    gridTemplateRows: 'repeat(3, 2px)',
                    padding: '4px 3px',
                    background: hovered ? 'var(--lh-accent-soft)' : 'var(--lh-border)',
                }}
            >
                {Array.from({ length: 6 }).map((_, i) => (
                    <span
                        key={i}
                        className="rounded-full"
                        style={{
                            width: 2,
                            height: 2,
                            background: 'var(--lh-fg)',
                            opacity: hovered ? 0.5 : 0.2,
                        }}
                    />
                ))}
            </div>
        </div>
    )
}
